import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPart from "./WaveDropPart";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ImageScale } from "@/helpers/image.helpers";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import type { DropContentPresentation } from "./dropContentPresentation";
interface WaveDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onLongPress: () => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
  readonly fullWidthMedia?: boolean | undefined;
  readonly hasTouch?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
const WaveDropContent: React.FC<WaveDropContentProps> = t0 => {
  const $ = _c(18);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onDropContentClick,
    onQuoteClick,
    onLongPress,
    setLongPressTriggered,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    fullWidthMedia: t5,
    hasTouch,
    onLinkCardActionsActiveChange,
    contentPresentation: t6
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const contentPresentation = t6 === undefined ? "default" : t6;
  const isTouchDevice = useIsTouchDevice();
  const effectiveHasTouch = hasTouch ?? isTouchDevice;
  let t7;
  if ($[0] !== activePartIndex || $[1] !== contentPresentation || $[2] !== drop || $[3] !== effectiveHasTouch || $[4] !== fullWidthMedia || $[5] !== isCompetitionDrop || $[6] !== isEditing || $[7] !== isSaving || $[8] !== mediaImageScale || $[9] !== onCancel || $[10] !== onDropContentClick || $[11] !== onLinkCardActionsActiveChange || $[12] !== onLongPress || $[13] !== onQuoteClick || $[14] !== onSave || $[15] !== setActivePartIndex || $[16] !== setLongPressTriggered) {
    t7 = <WaveDropPart drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} onLongPress={onLongPress} setLongPressTriggered={setLongPressTriggered} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} fullWidthMedia={fullWidthMedia} hasTouch={effectiveHasTouch} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} contentPresentation={contentPresentation} />;
    $[0] = activePartIndex;
    $[1] = contentPresentation;
    $[2] = drop;
    $[3] = effectiveHasTouch;
    $[4] = fullWidthMedia;
    $[5] = isCompetitionDrop;
    $[6] = isEditing;
    $[7] = isSaving;
    $[8] = mediaImageScale;
    $[9] = onCancel;
    $[10] = onDropContentClick;
    $[11] = onLinkCardActionsActiveChange;
    $[12] = onLongPress;
    $[13] = onQuoteClick;
    $[14] = onSave;
    $[15] = setActivePartIndex;
    $[16] = setLongPressTriggered;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default WaveDropContent;